var _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "url(#pattern0_1445_1691)",
    fillOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "black",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1445_1691",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1445_1691",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1445_1691",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAAAXNSR0IArs4c6QAAA3VJREFUeF7tnU1uE0EQhV/7DvzcAAkWHCAsYAMyRwBkS7ElxiDCWQiCDJIHaSzgCESwgQUcgAVI3CAhd3AjUEDEgGteT7fbzrxsp7qq631d1T0jOe2gv6wKuKzRFRwCkHkRCIAAZFYgc3hVgABkViBzeFWAAGRWIHN4VYAAZFYgc3hVwKYDGGxP+ujN+873LgD+MoBzmXNKHf4QcJ+8m3/FvLc/e7633yZgqwoYjosX8LjdZgIbP9bhZT0t74TmEQxgOCp8aNDTOK6uyiAtgwYNx8UOPB6dRiGDc3J4WE/LXXY8DWA4KrYAfGADdcT+Sl2VH5lcaQCDUfHEAfeYIF2x9cDTWVXeZ/KlAQxHxTsAV5kgHbJ9X1flNSbfEADfAJxhgnTI9qiuyrNMviEAlp5+Qk8DzKRz2lqnPzZ/ASBpCgApWGxzAYitKOlPAEjBYpsLQGxFSX8CQAoW21wAYitK+uscACthSz/2XG75s+bDxlv79wArYUswVhDLnzUfNp4AWIovPBcAUjB2RVruBcBSaOG5AJCCLZpbK85yLwCWQsZzAUi8CVl8BCAzgLaA1IIsBVs+typEAFoKbA0XgMTHPgHQHnBCgdgVt/afIlQBqgBVwLIqiN0SVl1xakGW4ok7gAAIAKlA4hVpzSZ2y1MFWIonBi4AAkAqkHhFWrNRCxKA5T/Oi/31cdUrctXxtAdYiieuOAEQAFKBxCvSmo02YQHQJrysSthDiPYAq+ckrjgBEABSgcQr0pqNNmEB0CasTfgPBWK3BLUgSwG1ILUgtSC1oP+vAfZNkOw4f5lrD1iQRAC4f9638W/CbSuIHR+74gSAJCAApGCxzQUgtqKkPwEgBYttLgCxFSX9CQApWGxzAYitKOlvHQAcdOCOABLLb/PDuirPM4MD3gMmbwB/nQnSHVv3tq72bjD50gAG47u7zrsHTJCu2HrnH8+mz3aYfHkA25O+c/41E6Qrtt67m+yVJjSAH2Lq6pJ/LKnAq0yCAPyEoCtMTlAI/QocDOC4EnSVSeDVJb/otQJwXAlbHrjlgIsALnXgboEjAJ898MUBr9grSxabV2sAXdlgU+UpAKmUbehXABoKlcpMAFIp29CvADQUKpWZAKRStqFfAWgoVCozAUilbEO/AtBQqFRmApBK2YZ+BaChUKnMBCCVsg39fgdyFch/AeLp+AAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneFilled);
export default __webpack_public_path__ + "static/media/OneFilled.1b9450ac3ff05bef69fa8d6c1413a1ce.svg";
export { ForwardRef as ReactComponent };